export const NPS_CHOOSE_RATING_TEST_ID = 'NPS_CHOOSE_RATING_TEST_ID';
export const NPS_EXPANDED_FORM_TEST_ID = 'NPS_EXPANDED_FORM_TEST_ID';
export const NPS_GOODBYE_MESSAGE_TEST_ID = 'NPS_GOODBYE_MESSAGE_TEST_ID';
export const NPS_ERROR_COMPONENT_TEST_ID = 'NPS_ERROR_COMPONENT_TEST_ID';
export const NPS_SKELETON_TEST_ID = 'NPS_SKELETON_TEST_ID';
